import React from 'react';
import { Button } from 'ui';
import Text, { TEXT_VARIANTS } from 'ui/Typography/Text';
import LearnExpertIcon from './LearnExpertIcon';

const LessonRequest = ({ onClick }) => (
  <div>
    <Text component="div" variant={TEXT_VARIANTS.BODY_LIGHT}>
      {t('learn.search.insufficient_results.prompt')}
    </Text>
    <Button onClick={onClick} className="mt-8" tall customColor>
      <LearnExpertIcon />
      {t('expert.action_button')}
    </Button>
  </div>
);

export default LessonRequest;
